/** @deprecated */
export function generateIcon({
  width = 12,
  height = width,
  className,
  icon,
}: {
  width?: number
  height?: number
  icon: string
  className?: string
}) {
  const attrs = [`width="${width}"`, `height="${height}"`]

  if (className) {
    attrs.push(`class="${className}"`)
  }

  return `<svg ${attrs.join(" ")}><use xlink:href="#${icon}"></use></svg>`
}
